import React from 'react';
import PropTypes from 'prop-types';
import BalanceSheet from './BalanceSheet';

const BalanceSheetPicker = ({ balanceSheetCollection }) => {
  if (!balanceSheetCollection) {
    return null;
  }

  const [balanceSheetResource] = balanceSheetCollection;

  return (
    <BalanceSheet balanceSheetResource={balanceSheetResource} />
  );
};

BalanceSheetPicker.propTypes = {
  balanceSheetCollection: PropTypes.object.isRequired,
};

export default BalanceSheetPicker;
